// extracted by mini-css-extract-plugin
module.exports = {"options":"NewOrder_options__2DjCs","textArea":"NewOrder_textArea__1YhVu"};